module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs__tab-container"
  }, [_vm._l((_vm.tabs), function(tab, index) {
    return [_c('a', {
      class: ("tabs__tab " + (tab.isActive ? 'tabs__tab--active' : '')),
      attrs: {
        "href": "javascript:;",
        "data-tab": tab.id,
        "data-property": tab.property
      },
      on: {
        "click": _vm.selectTab
      }
    }, [(tab.iconName) ? [_c('icon', {
      attrs: {
        "name": tab.iconName,
        "height": "24"
      }
    })] : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.name))])], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tabs__content-container"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28379aa2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue
// module id = 1048
// module chunks = 1